export class Project {
  constructor(
    path,
    name = null,
    duration = 10,
    idProj = null,
    tempId = null,
    socId = null,
    width = 0,
    height = 0,
    thumbnail = null,
    isTemplate = false
  ) {
    this.path = path;
    this.name = name;
    this.idProj = idProj;
    this.tempId = tempId;
    this.socId = socId;
    this.duration = duration;
    this.width = width;
    this.height = height;
    this.thumbnail = thumbnail;
    this.isTemplate = isTemplate;
  }
}
